


































































import {
  Component, mixins, mapState, Provide,
} from '@samclick-commons';

import SamclickMixins from '@/utils/mixins';
import {
  CommonsStore, Payload, TransactionsModuleStore,
} from '@samclick-store-factory';
import { formatDate, getStartOfCurrentMonth, getDateTodayIsoFormat } from '@/utils/date-utils';
import { sortString, toMoney } from '@/utils/common-utils';

class TransactionsState {
    public id: string | number = ''

    public transactionDate: Array<string> = []

    public transactionType: string | number = ''

    public transactionStatus: string | number = ''

    public displayDate: Array<string> = [getStartOfCurrentMonth(), getDateTodayIsoFormat()]
}

@Component({
  /**
   * Imported components
   * */
  components: { },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.transactionsmodule.transactionsModuleStore.loading,
      transactions: (state: any) => state.transactionsmodule.transactionsModuleStore.transactions,
      transactionType: (state: any) => state.commons.commonsStore.transactionType,
      transactionStatus: (state: any) => state.commons.commonsStore.transactionStatus,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class Transactions extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new TransactionsState();

    @Provide()
    ADD: string = 'New'

    @Provide()
    EDIT: string = 'Edit'

    @Provide()
    VIEW: string = 'View'

    payloadTemp = {}

    /**
   * Watchers
   * */
    /**
     * Methods
     * */
    @Provide()
    submitSearch() {
      const {
        transactionDate, transactionType, transactionStatus, displayDate,
      } = this.state;

      const payload = {
        transaction_start_date: transactionDate[0],
        transaction_end_date: `${formatDate(transactionDate[1])}T00:00:00.000Z`,
        trans_type: transactionType,
        trans_status: transactionStatus,
        display_start_date: displayDate[0],
        display_end_date: `${formatDate(displayDate[1])}T00:00:00.000Z`,
      };
      this.payloadTemp = payload;
      TransactionsModuleStore.getAffTransactions(new Payload(payload));
    }

    reset() {
      this.state = new TransactionsState();
      TransactionsModuleStore.destroyTransactions();
    }

    getTransactionType(type: number) {
      return CommonsStore.transactionType(type).label;
    }

    exportCsv() {
      const payload = {
        ...this.payloadTemp,
        headers: [
          this.$t('transactions.date'),
          this.$t('transactions.id'),
          this.$t('transactions.type'),
          this.$t('transactions.amount'),
          this.$t('transactions.details'),
        ],
      };
      TransactionsModuleStore.exportAffiliateTransaction(new Payload(payload));
    }


    toggleTransactionDialog(action: string, rowDtls: object = {}) {
      this.$refs.createUpdateDialog.toggleDialog(true, action, rowDtls);
    }

    onEnter(e: any) {
      if (e.key === 'Enter') {
        this.submitSearch();
      }
    }

    sortByTransType(a: any, b: any) {
      return sortString(this.getTransactionType(a.transaction_type), this.getTransactionType(b.transaction_type));
    }

    /**
     * Computed
     * */

    /**
     * Lifecycle hooks
     * */
    created() {
      window.addEventListener('keydown', this.onEnter); // will attach the event listener to the whole window when the component is created
    }

    destroyed() {
      window.removeEventListener('keydown', this.onEnter); // will detach the event listener once the component is destroyed
    }

    mounted() {
    }

    beforeUpdate() {
    }

    beforeCreate() {
      TransactionsModuleStore.destroyTransactions();
      this.dateUtils = {
        formatDate,
      };

      this.commonUtil = {
        toMoney,
      };
    }
}
